// extracted by mini-css-extract-plugin
export default {"LiveFeedContainer":"LiveFeed_LiveFeedContainer__4SLPm"};